import React, {Fragment, ReactNode} from "react";
import {useAppSelector} from "../../hooks/useRedux";
import {Navigate, useNavigate} from "react-router-dom";

// component props interface
interface AuthGuardProps {
    children: ReactNode;
}

const AuthGuard = ({children}: AuthGuardProps) => {
    const authSelector = useAppSelector(state => state.auth)

    if (!authSelector.user)
        return <Navigate to={"/login"}/>

    return <Fragment>{children}</Fragment>
}

export default AuthGuard
